<template>
  <a-button
    :style="{ width: '100%' }"
    @click="openMergeModal">
    Добавить ссылку на Bitrix
  </a-button>

  <a-modal
    v-model:open="isModalVisible"
    title="Добавить ссылку на Bitrix"
    ok-text="Добавить"
    cancel-text="Отмена"
    :ok-button-props="{ disabled: !leadId, loading }"
    @cancel="handleCancel"
    @ok="handleOk">
    <a-input
      v-model:value="leadId"
      type="number"
      min="1"
      placeholder="ID лида Bitrix"
      @press-enter="handleOk" />
  </a-modal>
</template>

<script>
import { api } from '@/api';
import { trackGoal } from '@/helpers/tracking';
import { message } from 'ant-design-vue';

export default {
  props: {
    currentPlanId: {
      required: true,
      type: Number,
    },
  },
  emits: ['after-ok'],
  data() {
    return {
      leadId: null,
      isModalVisible: false,
      loading: false,
    };
  },
  methods: {
    openMergeModal() {
      trackGoal('merge_plan_click');

      this.isModalVisible = true;
    },
    handleOk() {
      if (!this.leadId) {
        return;
      }

      this.loading = true;

      api.addBitrixLeadToCrmPlan(this.currentPlanId, {
        leadId: this.leadId,
      }).then(() => {
        this.$emit('after-ok', this.leadId);
        this.leadId = null;
        this.isModalVisible = false;
        message.success('Лид успешно добавлен');
      }).catch((error) => {
        message.error(error.message || 'Произошла ошибка при добавлении лида');
      }).finally(() => {
        this.loading = false;
      });
    },
    handleCancel() {
      this.leadId = null;
      this.isModalVisible = false;
    },
  },
};
</script>
